<template>
  <v-tooltip v-bind="{ [position]: true }" :color="color" :max-width="maxWidth" :disabled="disabled">
    <template v-slot:activator="{ on, attrs }">
      <!-- mdi icon takes priority; falls back to the info svg -->
      <v-icon
        v-if="icon"
        :size="iconWidth"
        :color="iconColor"
        v-bind="attrs"
        v-on="on"
        style="cursor: pointer;"
      >
        {{ icon }}
      </v-icon>
      <img
        v-else
        :width="iconWidth"
        :height="iconWidth"
        :src="iconSrc"
        :alt="alt"
        v-bind="attrs"
        v-on="on"
        style="cursor: pointer;"
      />
    </template>
    <!-- default slot allows rich content; falls back to the text prop -->
    <slot>
      <span class="tooltip-text">{{ text }}</span>
    </slot>
  </v-tooltip>
</template>

<script>
export default {
  name: "InfoTooltip",
  props: {
    text: {
      type: String,
      default: "",
    },
    // top | bottom | left | right
    position: {
      type: String,
      default: "bottom",
      validator: (v) => ["top", "bottom", "left", "right"].includes(v),
    },
    iconWidth: {
      type: String,
      default: "20px",
    },
    // pass an mdi name (e.g. "mdi-help-circle") to use a Vuetify icon instead of the svg
    icon: {
      type: String,
      default: "",
    },
    iconColor: {
      type: String,
      default: "",
    },
    iconSrc: {
      type: String,
      default: require("../assets/info.svg"),
    },
    alt: {
      type: String,
      default: "More Info",
    },
    color: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: [String, Number],
      default: 300,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
